module.exports = __webpack_public_path__ + "files/ChronoBIOline.cc2f99f2ce9affc4d7cf7182af4ce96b.pdf";